"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCloudOrderConfig = getCloudOrderConfig;
exports.saveCloudOrderConfig = saveCloudOrderConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
// 查询云发单配置
function getCloudOrderConfig() {
  return (0, _request.default)({
    url: '/portal/system/tenant/bizconfig/query',
    method: 'get',
    params: {
      configKey: 'YFD'
    }
  });
}

// 保存云发单配置
function saveCloudOrderConfig(config) {
  return (0, _request.default)({
    url: '/portal/system/tenant/bizconfig/save',
    method: 'post',
    data: {
      configKey: 'YFD',
      config: config
    }
  });
}